export type GoogleBaseMapTypes = 'roadmap' | 'hybrid';

export const enum GoogleBasemapNames {
    Roadmap = 'roadmap',
    Satellite = 'satellite'
}
